import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconProject24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3 5.5h8.4a.8.8 0 01.8.8v8.4a.8.8 0 01-.8.8H6.3a.8.8 0 01-.8-.8V6.3a.8.8 0 01.8-.8zM10.25 17H6.3A2.3 2.3 0 014 14.7V6.3A2.3 2.3 0 016.3 4h8.4A2.3 2.3 0 0117 6.3v3.95h1.5a2.25 2.25 0 012.25 2.25v6a2.25 2.25 0 01-2.25 2.25h-6a2.25 2.25 0 01-2.25-2.25V17zm1.5 0v1.5c0 .414.336.75.75.75h6a.75.75 0 00.75-.75v-6a.75.75 0 00-.75-.75H17v2.95a2.3 2.3 0 01-2.3 2.3h-2.95z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.298a.796.796 0 011.182-.697l3.976 2.202a.796.796 0 010 1.394l-3.976 2.202A.796.796 0 018 12.703V8.297z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconProject24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;